export default __webpack_public_path__ + "static/media/Suyane_Mike_HickDuarte_34448.41bac52e.jpg";